import { useRouter } from 'next/router';
import { Menu } from '@/utils/tos';

interface Props {
  menu: Menu;
  page?: string;
}

const Nav = ({ menu, page }: Props) => {
  const router = useRouter();
  const activePage = page ? page : Object.values(menu)[0].target;

  return (
    <div className="fixed left-0 top-12 flex h-12 w-full justify-center gap-20 self-start bg-neutral-900 p-3">
      {Object.values(menu).map(item => (
        <div
          data-active={activePage === item.target}
          className="cursor-pointer hover:text-azure-500 data-[active=true]:text-azure-500"
          key={item.title}
          onClick={() =>
            router.push(item.target, undefined, { shallow: true })
          }>
          {item.title}
        </div>
      ))}
    </div>
  );
};

export default Nav;
